import React, { useEffect, useRef } from "react";
import "./cursor-glow.css";

export default function CursorGlow() {
  const ref = useRef(null);
  const posRef = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const rafRef = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    function update() {
      rafRef.current = null;
      const { x, y } = posRef.current;
      el.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px)`;
    }

    function onMove(e) {
      const clientX = e.clientX ?? (e.touches && e.touches[0].clientX);
      const clientY = e.clientY ?? (e.touches && e.touches[0].clientY);
      if (typeof clientX !== "number" || typeof clientY !== "number") return;
      // position the glow slightly below the pointer
      posRef.current.x = clientX;
      posRef.current.y = clientY + 14;
      if (!rafRef.current) rafRef.current = requestAnimationFrame(update);
      // ensure visible
      el.style.opacity = "0.92";
    }

    function onLeave() {
      if (el) el.style.opacity = "0";
    }

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("touchmove", onMove, { passive: true });
    window.addEventListener("mouseout", onLeave);
    window.addEventListener("mouseleave", onLeave);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("mouseout", onLeave);
      window.removeEventListener("mouseleave", onLeave);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return <div ref={ref} className="cursor-glow" aria-hidden="true" />;
}
